import axios from "axios";
import config from "./config";
import { apiKey, subDomain, contentType } from "./ThinkificConfig";
import store from "./store";
import { push } from "react-router-redux";

export const thinkificClient = axios.create({
  baseURL: config.thinkificBaseUrl
});

export const client = axios.create({ baseURL: config.baseUrl });
// Request interceptor
client.interceptors.request.use(
  function(config) {
    const token = localStorage.getItem("authorization") || "";
    config.headers = { authorization: token };
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Response interceptor
client.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      localStorage.clear();
      store.dispatch(push("/"));
    }
    return Promise.reject(error);
  }
);

export default client;

thinkificClient.defaults.headers.common["X-Auth-API-Key"] = apiKey;
thinkificClient.defaults.headers.common["X-Auth-Subdomain"] = subDomain;
thinkificClient.defaults.headers.common["Content-Type"] = contentType;

export const rawClient = axios.create({ baseURL: config.baseUrl });



// WEBPACK FOOTER //
// ./src/ajax.js